<template>  
  <div id="panoframe">
    <!-- Loading -->
    <loading 
      :active="isLoading"      
      loader="spinner"
      :height="100"
      :width="200"
      color="#005ca9"      
      :opacity="0.06"
      :is-full-page="true"
    ></loading>    

    <Krpano
      @loading="getLoading"
      @unlock="unLock"
      @clicked="onClickSpot"        
      @panocurrent="getCurrent"
      @loaded="panoloaded"        
      @state="getState"
      :panotitle="panotitle"
      :panoinfo="panoinfo"
      :unlocked="unlocked"
      :panocurrent="panocurrent"
      :source="panoitems"
      :queryid="query"
      :roomid="room"
      ref="panoComponent"
    ></Krpano>      

    <!-- Radar -->          
    <PanoRadar
        v-if="panocurrent && locationdata"
        @switchPanoOff="switchPanoOff"
        :locationdata="locationdata"
        :panocurrent="panocurrent"
        :position="position"
        :map="map"
    ></PanoRadar>

    <!-- Dialog -->
    <template>
      <v-layout row justify-center class="dialogframe">      
        <v-dialog 
          v-model="dialog" 
          :content-class="getDialogClasses(currentitem)"
          persistent @keydown.esc="onClickSpot(false)" 
          ref="panoSpot" v-if="destroyComponent"            
          scrollable
          :retain-focus="false"
          >
          <v-card
            :class="{audiotour: currentitem.location && tourdata !== null}"
            >
            <div class="titlewrap">
              <div class="wiwo21" v-if="currentitem.pdfpath != 'null'">
                <img :src="'/'+$home+'files/images/wiwo23.jpg'" alt="" />
              </div>

              <div class="headline padding" v-html="currentitem.spottitle" v-if="currentitem.spotid != 362"></div>
              <div class="actionsmall">
                <v-btn 
                  @click="onClickSpot(false)"
                  depressed
                  icon
                  >
                  <v-icon>mdi-close-thick</v-icon>
                </v-btn>
              </div>

            </div>            
            <!--
            <div v-if="currentitem.cat == 1">
              WIWO
            </div>
            -->
            
            <template v-if="currentitem.pdfpath != 'null'">   
              <div class="pdfcontent">
                <div style="float:right;">
                  <a :href="currentitem.pdfpath" target="_blank" >
                  <v-icon 
                    class="px-5 py-3"
                    size="20"
                    >mdi-open-in-new</v-icon>
                  </a>
                </div>
                <div v-if="currentitem.spotcontent != '<p>undefined</p>'" v-html="currentitem.spotcontent"></div>
              </div>
              <iframe @load="iframeLoaded" id="iframe" height="100%" width=100% :src="currentitem.pdfpath + '#zoom=page-width'" ></iframe>                              
            </template>            
            
            <v-card-text v-else>
              <div 
                class="tourmap" 
                  v-if="(currentitem.location && tourdata !== null) && tourdata && tourdata.length > 0 && (tourdata[0].tour_id === 69 || tourdata[0].tour_id === 70)" 
                  >
                  <!--
                  <PanoMap
                    v-if="panocurrent && locationdata"
                    :locationdata="locationdata"
                    :panocurrent="panocurrent"
                    :currentitem="currentitem"
                    :position="position"
                    :tourdata="tourdata"
                    :map="map"
                  ></PanoMap>
                  -->
                  <PanoMapOSM
                    v-if="panocurrent && locationdata"
                    :locationdata="locationdata"
                    :panocurrent="panocurrent"
                    :currentitem="currentitem"
                    :position="position"
                    :tourdata="tourdata"
                    :map="map"
                  ></PanoMapOSM>
                  <!--
                <PanoMapLeaflet 
                  :dialog-open="dialog"
                  :points="latLong"
                  :orsApiKey="$config.VUE_APP_ORS_KEY"
                  :orsProfile="'foot-walking'"
                  />
                -->
              </div>
              <div v-html="currentitem.spotcontent"></div>
            </v-card-text>

            <div 
              v-if="currentitem.location"
              style="position:relative;padding: 10px 20px; bottom:0;height: 0;"
              >
            </div>

            <!-- Aktion bottom -->
            <v-card-actions class="poi-action bottom mr-1 mb-1">          
              <div v-if="currentitem.tours !== null && tourdata === null" class="tourwrap">              

                <div class="tours">
                  <v-menu                    
                    top                
                    offset-y                                      
                    >
                    <template v-slot:activator="{ on, attrs }">
                      Diese Infotafel ist Teil eines Rundgangs.
                      <v-btn
                        color="#999"                      
                        v-bind="attrs"
                        v-on="on"
                        depressed
                        style="font-size:.8rem;"
                      >
                        <v-icon class="mr-4">mdi-map-marker-multiple-outline</v-icon> Tour starten
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-item
                        v-for="(item, index) in currentitem.tours"
                        :key="index"
                        dense
                      >
                        <v-list-item-title class="menuitem" @click="getTourData(item.id, currentitem.spotid)" :title="item.name">
                          {{ item.name }}                      
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>

                </div>

              </div>
              
            </v-card-actions>

          </v-card>      
        </v-dialog>        
      </v-layout>
    </template>

    <!-- Tour controls -->
    <template>
      <div class="text-center">
        <v-bottom-sheet
          v-model="sheet"
          max-width="900px"
          hide-overlay
          content-class="tourcontrol"        
        >

          <v-sheet
            class="text-center"
            height="54px"
          >
            <div 
              v-if="tourdata !== null && spotIsInTour(tourstatus) && dialog"                     
              class="controlswrap"
              >

              <div
                class="d-prev" 
                @click="onClickTourSpot(tourdata[touritemPrev].id)" 
                :title="tourdata[touritemPrev].name + ' / pi: ' + touritemPrev"                         
                >                
                <v-icon
                  size="28"
                  dense
                  round
                  color="#666"
                >
                mdi-chevron-left
                </v-icon>                
              </div>

              <div 
                class="d-next" 
                @click="onClickTourSpot(tourdata[touritemNext].id)" 
                :title="tourdata[touritemNext].name"                           
                >                
                  <v-icon
                    size="28"
                    dense                  
                    color="#666"
                  >
                  mdi-chevron-right
                  </v-icon>                
              </div>  

              <div 
                class="tourinfo" 
                v-if="tourdata !== null && spotIsInTour(tourstatus) && dialog"       
                >
                <b>{{ spotIsInTour(tourstatus).name }}</b>  {{ (touritemActive+1) }} / {{ tourdata.length}}
              </div>

              <v-btn                    
                color="#eee"                                                              
                depressed
                style="font-size:.8rem;"
                @click="resetTourData()"
                v-if="tourdata !== null && spotIsInTour(tourstatus) && dialog"                     
                >
                  <v-icon class="mr-4">mdi-map-marker-off-outline</v-icon> Tour stoppen
              </v-btn>

            </div>

          </v-sheet>
        </v-bottom-sheet>
      </div>
    </template>

    <!-- Controls button: toggle menu -->
    <div class="controlsopen" :class="{ active: controls.visible == false }">
      <v-tooltip left color="#333">
      <template v-slot:activator="{ on, attrs }">        
      <v-btn       
        @click="toggleMenu()"      
        tile                            
        v-bind="attrs"
        v-on="on"
        color="rgba(255,255,255,0.8"      
        >
        <v-icon        
          >
          mdi-menu-open
        </v-icon>
      </v-btn>
      </template>
      <span>Navigationsleiste einblenden</span>
      </v-tooltip>
    </div>

    <!-- Controls -->
    <v-container class="controls overflow-y-auto" fluid id="scroll-target" :class="{ active: controls.visible }">
      <v-tooltip left color="#333333">
        <template v-slot:activator="{ on, attrs }">
          <v-btn 
            @click="toggleMenu()"
            icon
            depressed
            class="controlsclose"
            v-bind="attrs"
            v-on="on"
            >
            <v-icon
              color="#999"
              >
              mdi-arrow-expand-right
            </v-icon>
          </v-btn>
        </template>
        <span>Navigationsleiste ausblenden</span>
      </v-tooltip>

      <v-row
          v-scroll:#scroll-target="onScroll"
          class="controlsinner"
        >
          <v-card
          class="panoinfo"
          flat        
          tile
          v-if="panocurrent"
          >        
            <h2 class="list-header" v-html="panocurrent.name"></h2>
            <div class="infocontent" v-html="panocurrent.content"></div>
          </v-card>
          <!--
          <v-card class="news" v-if="panocurrent && panocurrent.id === 128">
            <div class="img">
            <img @click="switchPanoOff(689)" class="hoverclick" :src="'/'+$home+'files/images/wiwo25.jpg'" alt="" />
            </div>
            <h2 class="list-header">14. Wildauer Wissenschaftswoche</h2>    
            <div class="infocontent">
            <p>
              Die Wissenschaftswoche präsentiert sich wieder vom 10. bis 14. März 2025 unter dem bewährten Motto:<br>
              FORSCHEN. ANWENDEN. BEGREIFEN.</p>
            <p>Die digitale Posterausstellung können Sie sich hier ansehen:<br>
            <a @click="switchPanoOff(689)">Virtuelle Ausstellung</a><br>
            </p>
            <p>Mehr Informationen unter: <a href="https://www.th-wildau.de/forschung-transfer/wissens-und-technologietransfer/veranstaltungen-und-termine/14-wildauer-wissenschaftswoche" target="_blank">www.th-wildau.de</a></p>
            </div>
          </v-card>
          -->

          <!-- Home page news:
          <v-card class="news">
            <div class="img">
            <img :src="'/'+$home+'files/images/ukrainische-akademie2023.jpg'" alt="" />
            </div>
            <h2 class="list-header">Ukrainische Akademie: Vergangenheit, Gegenwart und Zukunft</h2>    
            <div class="infocontent">        
            <p>
            Ein Ausstellung in der Bibliothek der Technischen Hochschule Wildau.<br>
            <a @click="switchPanoOff(191)">Virtuelle Austellung ansehen (Ukrainische Akademie in Kriegszeit)</a><br>
            <a @click="switchPanoOff(192)">Virtuelle Austellung ansehen (Unissued Diploma)</a>
            </p>
            <p>Mehr Informationen unter: <a href="https://www.th-wildau.de/hochschule/aktuelles/solidaritywithukraine/ausstellung-ukrainische-akademie/" target="_blank">www.th-wildau.de</a></p>
            </div>
          </v-card>
          -->
          
          <v-card
              class="panomenu"
              flat
              v-if="panocategories"
            >
            
              <v-list dense class="panolist">

                <v-list-item-group>

                  <!--<div class="list-header" v-bind="paninfo">{{paninfo}}XXX</div>-->

                  <div class="list-header"><v-icon size="24" class="pr-2" style="margin-top:-3px">mdi-location-enter</v-icon>Einstiegspunkte</div>

                  <!-- Pattern for tours (!)
                  <v-list-item
                    v-for="(item, i) in panoenters"
                    :key="i"
                    @click="switchPanoOff(item.id);toggleMenu()"
                  >

                      <v-list-item-icon class="mx-0" >
                        <v-icon>mdi-map-marker</v-icon>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title v-text="item.name"></v-list-item-title>
                      </v-list-item-content>

                  </v-list-item>
                  -->

                  <v-treeview
                    v-model="tree"                  
                    :items="panoenters"                  
                    activatable
                    item-key="name"
                    open-on-click
                    off-icon=""
                    transition                    
                  >
                    <template v-slot:label="{ item }">
                        <div @click="switchPanoOff(null)" v-if="item.children">{{ item.name }}</div>
                        <div @click="switchPanoOff(item.id)" v-else-if="item.id">{{ item.name }}</div>
                        <div @click="switchPanoOff(item.idx,item.pid)" v-else>{{ item.name }}</div>
                    </template>
                  </v-treeview>                                

                </v-list-item-group>
              </v-list>

          </v-card>          

      </v-row>      

    <Logos v-if="template !== 'icampus'"></Logos>

    </v-container>    

  </div>
</template>

<script>

import Krpano from '../components/content/Krpano';
//import Xmlformat from '../components/tools/xmlformat';
import PanoRadar from '../components/controls/PanoRadar';
// import PanoMap from '../components/controls/PanoMap';
// import PanoMapLeaflet from '../components/controls/PanoMapLeaflet';
import PanoMapOSM from '../components/controls/PanoMapOSM';
import Logos from '../components/elements/Logos';
import Loading from 'vue-loading-overlay';
import { eventBus } from '../main.js';

export default {
  name: 'PanoramaFrame',
  props: ['query','map', 'room', 'tour','poiid', 'controls'],

  components: {
    //Xmlformat
    //xmlbuilder    
    Krpano,
    PanoRadar,
    // PanoMap,
    // PanoMapLeaflet,
    PanoMapOSM,
    Loading,
    Logos
  },

  data(){
    //const vm = this;
    return {     
      latLong: [],         
      internalPoiid: this.poiid,
      scene: "scene name",
      hooks:{
          sceneChanged(scene){
              console.log(scene);
              //event handler
          }
      },                 
      route: this.$route,
      destroyComponent:true,      
      isLoading: true,
      tree: [],
      spotDialog: null,
      inset: true,
      panoitem: 1,
      panoitems: null,
      panocategories: null,
      panoenters: [],
      right: null,
      panotitle: null,
      panoinfo: null,
      panocurrent: null,            
      locationdata: null,      
      tourdata: null,
      touritemActive: null,
      touritemPrev: null,
      touritemNext: null,
      sheet: false,
      tourstatus: {
        id: null
        // active: false
      },
      currentitem: {
        spotcontent: "",
        spottitle: "",
        panoid: null
      },
      singleLoadedPano: null,
      dialog: false,
      // Lock dialog window deactived
      lockdialog: false,      

      unlocked: false,
      password: '',
      queryid_to_unlock: null,
      show1: false,
      position: {},
      coltype2: false,
      coltype3: false,
      coltype4: false,
      coltype6: false,
      coltype7: false,
      coltype8: false,
      coltype9: false,
      controlsHidden: false,
      pdfCurrentPage: 0,
      numPages: 0,
      loadedRatio: 0,
      pwrules: {
          required: value => !!value || 'Passwort wird benötigt'
      },
      pwerror: '',
      template: null
    }
  },

  methods: {

      getDialogClasses (curr) {
        let dialogclasses = '';
        dialogclasses = curr.pdfpath != 'null' ? 'pdf-wide '+dialogclasses : 'main-dialog '+dialogclasses;
        dialogclasses = curr.tours ? curr.tours[0].name + ' ' + dialogclasses : dialogclasses;
        return dialogclasses;
      },

      iframeLoaded() {
        /*
        let iframe = document.getElementById("iframe");
        if (iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document)) {
          iframe.contentWindow.document.querySelector("img").style.maxWidth = "100%";
        }
        */
      },

      displayData(data) {
        console.log(data);
      },
      
      getPanoData() {
        // console.log('getPanoData()');
        let self = this;
        this.axios.get( this.$config.host+"/panoslocation/" + this.$key ).then(function (response) {
            // console.log('GET PANOS');
            // console.log(response.data);
            self.panoitems = response.data;                 
            self.panotitle = self.panoitems[0].name;
            self.panoinfo = self.panoitems[0].content;
            self.panocurrent = self.panoitems[0];
            setTimeout(() => self.getPanoCategories(), 1500);
            self.checkTour();
            self.checkPoi();
        });
      },
      getSinglePanoData(id, callback) {      
        console.log('GET PANO Single');
          let single = null;
          this.axios.get( this.$config.host+"/pano/" + id ).then(function (response) {
            single = response.data;
            callback(single);
          });
      },      
      getPanoCategories() {          
          let self = this;
          this.axios.get( this.$config.host+"/panocategories" ).then(response => (
            self.panocategories = response.data,
            self.getPanoEnters()            
          ));
      },
      getTourData( tourid, spotid) {
          this.sheet = true;
          let self = this;
          this.axios.get( this.$config.host+"/tourdata/"+tourid ).then(response => (
            self.tourdata = response.data,
            self.setTourLatLong(response.data),
            self.setTourStatus(tourid),
            // Get index of active tour item
            self.getTourIndex(spotid)                     
          ));
      },
      getTourIndex (spotid) {        
        var length = this.tourdata.length;
        if(length > 0) {          
          this.touritemActive = this.tourdata.findIndex(item => item.id === spotid);
          this.touritemPrev = (this.touritemActive - 1) < 0 ? (length - 1) : (this.touritemActive - 1);
          this.touritemNext = (this.touritemActive + 1) > (length - 1) ? 0 : (this.touritemActive + 1);
        }
      },
      setTourStatus (tourid) {
        this.tourstatus.id = tourid;        
      },
      setTourLatLong (tourdata) {
        let self = this;
        tourdata.forEach((value) => {
          if(value.loc_x && value.loc_y) {
            let thisLatLon = self.locToLatLon(value.loc_x, value.loc_y, value.name);
            self.latLong.push([thisLatLon.lat, thisLatLon.lon]);
          }
        });
      },
      spotIsInTour(tourlive) {
        // console.log('spotIsInTour - Spot in aktiver Tour?');
        if(this.currentitem.tours) {
          // console.log('this.currentitem.tours (nach PID) vorhanden!');
          // console.log(this.currentitem.tours);
          // console.log('welche ist live?');
          // console.log(tourlive);          
          
          var active = this.currentitem.tours.find(x => x.id === tourlive.id);      
          return active
        } else {
          return false
        }         
      },
      spotIdIsInTourTour(tourdata, spotid) {
        // console.log('spotIdIsInTourTour()');
        // console.log(tourdata);
        // console.log(spotid);
        
        if(tourdata) {
          var active = tourdata.find(x => x.id === spotid);      
          return active
        } else {
          return false
        }         
      },      
      resetTourData () {          
          this.tourdata = null;
          this.touritemActive = null;
          this.touritemPrev = null;
          this.touritemNext = null;
          this.sheet = false;
      },    
      getLocationData() {
        let self = this;
        this.axios.get( this.$config.host+"/locationsdata" ).then(function (response) {                    
          self.locationdata = response.data;
        });
      }, 
      getPanoEnters() {                    

          let self = this;

          if(this.panoitems && this.panocategories) {
                                  
            this.panocategories.forEach((value) => {

              // console.log(this.panocategories);
              
              var children =  this.panoitems.filter(function(item) { 

                return ( item.cat_id == value.id && 
                    self.panocurrent.loc_key == item.loc_key &&
                    (
                      (self.template == 'innoxr' && (item.enterx == true || item.enterb == true)) ||
                      (self.template == 'default' && (item.enterx == true || item.enterb == true)) ||
                      (self.template == 'icampus' && item.enter == true)
                    )
                    );
              });              

              children.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));

              if(children.length > 0) {
                self.panoenters.push({
                  name:value.name,
                  children: children
                });              
              }            
            });

            // console.log(self.panoenters);

            self.panoenters.push({
               name: 'Touren',
               children: [
                {
                  name: 'Audio-Guide Architektur Halle 10',
                  idx: 128,
                  pid: 1775
                },
                {
                  name: 'Campus Audiotour 1',
                  idx: 128,
                  pid: 1842
                },
                {
                  name: 'Campus Audiotour 2',
                  idx: 128,
                  pid: 1852
                }                
               ]
            });

          }
      },
      switchPanoOff(item, poiid){
        if(!item && !poiid) return false;
        // console.log('switchPanoOff ausgelöst - Klick auf Tour');
        
        if(window.innerWidth < 760) {
          this.toggleMenu(false);
        }
          
        if(item == null) return false;          
        
        //this.isLoading = true;
        this.$refs.panoComponent.switchPano(item);  
        if(poiid) {
          // console.log('pooid laden');
          this.poiid = poiid;
          setTimeout(() => this.checkPoi(), 200); 
        }
      },
      onClickTourSpot (spotid) {        
        // console.log('onClickTourSpot:');
        // console.log(spotid);
        
        this.setInfospot(spotid);
        this.getTourIndex(spotid);
      },
      /**
       * Open POI
       * title = false : close POI
       * to do: Check if tour is active or not!
       */
      onClickSpot (title, content, spotid, icon, tours, cat, pdf) {
        // console.log('onClickSpot aufgerufen: ');
        // console.log('zugehörige Touren?', tours);

        if(!title) {

          // Close all hotspots in VR mode
          this.$refs.panoComponent.closePois();

          this.dialog = false;
          this.destroyComponent = false;

        } else {

          if(icon === 'intro') {
 
            spotid = parseInt(spotid);
            
            var activePano = this.panoitems.find(pano => pano.spots.some(item => item.id === spotid));

            if(activePano) {

              var activeSpot = activePano.spots.find(spot => spot.id === spotid);    
                          
              this.currentitem.spotcontent = this.renderHtmlContent(activeSpot.body);
              this.currentitem.spottitle = activeSpot.linktitle;
              this.currentitem.spotid = activeSpot.id;
              this.currentitem.tours = (activeSpot.tours && activeSpot.tours.length > 0) ? activeSpot.tours : null;
              this.currentitem.cat = activeSpot.cat;
              this.currentitem.pdfpath = activeSpot.pdfpath;

              this.dialog = true;
              this.destroyComponent = true;
              
            }

          } else {
                        
            if(!title) {
              //console.log("no title");
              //this.resetTourData();
            } else {

              this.currentitem.location = {
                id: this.panocurrent.loc_id,
                name: this.panocurrent.loc_name,
                src: this.panocurrent.loc_src,
                x: this.panocurrent.loc_x,
                y: this.panocurrent.loc_y,
              }
              
              var thistours = (tours && tours.length > 0) ? tours : null;
              // console.log('thistours');
              // console.log(thistours);
              this.currentitem.spotcontent = this.renderHtmlContent(content);
              this.currentitem.spottitle = title;
              this.currentitem.spotid = spotid;            
              this.currentitem.tours = thistours ? thistours : null;
              this.currentitem.cat = cat ? cat : null;
              this.currentitem.pdfpath = pdf ? pdf : 'null';
              // this.currentitem.tourClass = (this.currentitem.tours && this.currentitem.tours.length > 0) ? this.currentitem.tours[0].name : null;
              this.currentitem.tourClass = (thistours && thistours.length > 0) ? thistours[0].name : null;

              this.dialog = true;
              this.destroyComponent = true;

            }            
            
          }
        
          /* 
           * Activated control bar when tourdata is available
          */
          // console.log('this.tourstatus - aktive Tour?');
          // console.log(this.tourstatus);
          
          if( 
            this.spotIsInTour(this.tourstatus) &&
            // this.spotIdIsInTourTour(this.tourdata, spotid) &&
            this.tourdata !== null && 
            this.dialog
          ) {
            // console.log('Spot is in current tour!');
            setTimeout(() => this.sheet = !this.sheet, 500); 
          } else {
            // console.log('Spot is NOT in current tour!');
            this.sheet = false;
            this.resetTourData();
          }

        }          
          
      },
      setInfospot (spotid, done) {
        // console.log('setInfospot - spotid:', spotid);
        
        let self = this;
        var activePano = this.panoitems.find(pano => pano.spots.some(item => item.id === spotid));

        // Load single pano with extended ressource
        this.getSinglePanoData(activePano.id, function (result) {
          // console.log('result?', result);
          if(result) {
            activePano = result;
          
            let activeSpot = activePano.spots.find(spot => spot.id === spotid);
            self.currentitem.spottitle = activeSpot.linktitle;
            self.currentitem.spotcontent = activeSpot.body;
            self.currentitem.panoid = activePano.id;
            self.currentitem.tours = activeSpot.tours;
            self.currentitem.pdfpath = activeSpot.pdfpath;

            // switch pano:
            // if(!spotid) {
              // console.log('spotid?', spotid);
              // console.log('switch pano');
              self.switchPanoOff(activePano.id);
            // }
            
            if (typeof done === 'function') {
              done(self.currentitem);
            }
          }

        });

      },
      /**
       * If a tour is requested in URL
       */
      checkTour () {
        // console.log('checkTour:');
        // console.log(this.tour);
        if(this.tour !== undefined) {       

          this.onClickSpot('Titel', 'Content', this.tour, 'intro');
        } else {
          //console.log("tour id is NOT set");
        }
      },
      /**
       * If a poi is requested in URL
       */
      checkPoi () {
        // console.log('checkPoi aufgerufen', this.poiid);
        let self = this;
        if(self.poiid !== undefined) {
          /**
           * Set infospot and available tours
           *  */ 
          self.setInfospot(self.poiid, (item) => {
            // console.log('Callback: currentitem (nach PID) ist bereit', item);
            self.onClickSpot (item.spottitle, item.spotcontent, self.poiid, 'x', self.currentitem.tours);
          });

        } else {
          // console.log("poiid is NOT set");
        }
      },      
      /**
       * Internal check poiid
       */
      checkPoiInternal (poiid) {
        // console.log('checkPoiInternal aufgerufen');
        if(poiid !== undefined) {    
          this.setInfospot(poiid);
          this.onClickSpot ('Titel', 'Content', poiid);
        } else {
          // console.log("poiid is NOT set");
        }
      },      
      onScroll () {
          //console.log("scrolling");
      },      
      getState (value) {                
          this.position = value;
      },
      panoloaded() {
          //console.log("panoLoaded!");
      },
      getTitle (value) {
          this.panotitle = value;
      },
      getCurrent (value) {
        let self = this;
        // console.log('load current pano again.. ');
        let indexCurrentpano = this.panoitems.findIndex( pan => pan.id == value.id );
        // console.log(this.panoitems[indexCurrentpano]);
          
        this.getSinglePanoData(value.id, function (result) {

          // Remove duplicate locations
          let removeDuplicates = result.location.filter((obj1, i, arr) => arr.findIndex(obj2 => (obj2.pid === obj1.pid)) === i);
          result.location = removeDuplicates;

          if(result) {
            self.panoitems[indexCurrentpano] = result;
          }
        });
        this.panocurrent = value;
      },
      getInfo (value) {
          this.panoinfo = value;
      },
      getLoading (value) {
          this.isLoading = value;
      },
      unLock ( queryid ) {        
        this.isLoading = false;
        this.lockdialog = true;
        this.queryid_to_unlock = queryid;
      },
      breakunlock () {
        this.lockdialog = false;
        this.isLoading = false;
      },
      focus () {                
        this.$nextTick(() => this.$refs.pw.$el.focus())        
      },
      submitUnlock () {        

        if(this.password === 'ebs2021wildau') {          
          this.unlocked = true;
          this.lockdialog = false;

          if(this.queryid_to_unlock) {
            setTimeout(() => {
              this.switchPanoOff(this.queryid_to_unlock)            
            }, 200);          
          }        

        } else {

          this.pwerror = 'Sie haben ein falsches Passwort eingegeben.'

        }

      },      
      setSpotsVisibility () {          
          // console.log(value);
          //this.$refs.panoComponent.setSpots(value);
      },      
      toggleMenu(bool) {
        if(bool == false) {
          this.controls.visible = bool;
        } else {
          this.controls.visible = !this.controls.visible;
        }
      },
      renderHtmlContent(html) {
          if(html) {
            return html.replaceAll('/vr/bilder/', '/vr/files/images/');
          } else {
            return html
          }         
      },
      progress() {
        //console.log("progress!");
        //console.log(ev);
      },
      /**
       * loc (0..1) -> WGS84 lat/lon
       * Ursprung: oben links (loc_x=0, loc_y=0)
       * Bekannte Referenz: oben links (TL) und unten rechts (BR) der GEDREHTEN Karte.
       *
       * Annahme: normiertes System ist quadratisch (1.0 in x == 1.0 in y in Meter-Skalierung).
       *
       * @param {number} loc_x 0..1 (links -> rechts)
       * @param {number} loc_y 0..1 (oben -> unten)
       * @returns {{lat:number, lon:number}}
       */
      locToLatLon(loc_x, loc_y) {

        // console.log(loc_x + ' | ' + loc_y + ' -> ' + name);

        // Referenzpunkte: TL (oben links) und BR (unten rechts)
        const lat0 = 52.320660; // TL
        const lon0 = 13.628567;

        const lat1 = 52.316197; // BR
        const lon1 = 13.633112;

        // Lokale Meter-pro-Grad-Näherung (für kleine Gebiete)
        const mPerDegLat = 111320.0;
        const mPerDegLon = 111320.0 * Math.cos((lat0 * Math.PI) / 180.0);

        // TL -> BR in Metern (East/North)
        const dN = (lat1 - lat0) * mPerDegLat;
        const dE = (lon1 - lon0) * mPerDegLon;

        // Quadratannahme: Diagonale im Normsystem hat Länge sqrt(2)
        const diagM = Math.hypot(dE, dN);
        const s = diagM / Math.sqrt(2); // Meter pro 1.0 Norm-Einheit

        // Winkel bestimmen:
        // Wir rechnen intern im System (x rechts, y oben).
        // TL->BR ist im loc-System (1,1), aber y oben => dy=-1 => v = (1, -1)
        const dirV = Math.atan2(-1.0, 1.0); // -45°
        const dirEN = Math.atan2(dN, dE);   // Richtung TL->BR in der Realität
        const theta = dirEN - dirV;

        // Punkt relativ zu TL:
        const dx = loc_x;
        const dy = -loc_y; // y nach oben

        // Rotation + Skalierung: (dx,dy) -> (E,N)
        const cosT = Math.cos(theta);
        const sinT = Math.sin(theta);

        const E = s * (cosT * dx - sinT * dy);
        const N = s * (sinT * dx + cosT * dy);

        // Zurück nach Lat/Lon (Offset ab TL)
        const lat = lat0 + (N / mPerDegLat);
        const lon = lon0 + (E / mPerDegLon);

        return { lat, lon };
      },
      onMessage(event) {
        console.log("Empfangen:", event.data);
      }      
  },

  beforeMount() {
      this.getPanoData();
      this.getLocationData()      
  },

  mounted() {      
    window.addEventListener("message", this.onMessage);
    this.template = this.$template;      
  },

  created() {

    if (this.$route.query.q === "133") {
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, q: "137" }
      })
    }

    console.log('created()');
    eventBus.$on('controls-visible', clickCount => {            
      this.controls.visible = clickCount
    });        
  },

  watch: {
    locationdata: function (e) {
      this.locationdata = e;
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.v-icon {
  margin-right:0 !important;
}

.v-list-item--link::before {
  background-color:transparent;
}
.v-item--active {
    background-color:transparent;
}
.menuitem:hover {
  cursor: pointer;
}
.controlsopen {
  position:fixed;
  top:70px;
  right:16px;  
  display:none;
}
.controlsopen.active {
  display:block;
}
.controls {
  position:fixed;
  display:none;
  top:0;
  right:0;
  width:28%;
  height:100%;
  padding-top:62px;
  padding-left:10px;
  padding-right:10px;
  z-index: 5;
  background-color: rgba(13, 29, 62, 0.86);
}
.controls >>> a {
  color:#79a7cf;
  text-decoration: none;
}
.controls >>> a:hover {  
  text-decoration: underline;
}
.controls .controlsclose {
  position:fixed;
  left:auto;
  bottom:6px;
  z-index: 99;
}
.controls .v-card,
.controls .v-list {
  background-color: transparent;
  color:#f7f7f7;
}
.controls.active {
  display:block;
  width:100%;
}
.controlsinner {
  margin-left:0;
  margin-right:0;
  padding-bottom:30px;
}
.panoinfo {
  padding-top:8px;
  padding-bottom:8px;
  margin-bottom:8px;
  width:100%;
  min-height:3rem;  
}
.panoinfo >>> .list-header {
  font-weight: normal;
  font-size:1.4rem !important;
}
.pano .list-header {
  font-size: 0.92rem;
}
.list-header {
  padding:10px 16px 10px;
}
.infocontent {
  padding-bottom:20px;
  margin:0px 16px;
  font-size:0.92rem;
  border-bottom:1px solid #999;
}
.infocontent >>> p {  
  font-size:0.92rem;
  margin: 0 0 10px;
}
.news {
  padding:0;
}
.news .img {
  padding:0 16px;  
}
.news .img img {  
  max-width:100%;
}
.panomenu {
  position:static;
  top:56px;
  right:20px;
  width:100%;
  padding-bottom:14px;
  margin-bottom:1.2rem;  
}
.panomenu .v-btn {
  padding: 0 12px !important;
  height:28px !important;
  font-size:0.7rem;
}

.panoinfo div,
.panoinfo p,
.panomenu >>> .v-treeview-node__label,
.panomenu >>> .theme--light.v-icon {
  color:#e1e4e5 !important;
}
.panomenu >>> .list-header {
  color:orange;
  font-weight: bold;
  font-size:1.2rem;
}

.controls >>> .v-treeview {
  padding:0 14px;
}
.controls >>> .v-treeview-node__root {
  min-height: auto;
  padding:4px 0px 
}
.controls >>> .v-treeview-node__level {
  width:12px;  
}
.controls >>> .v-treeview-node__label {
  white-space: normal;
  font-size:0.92rem;  
}
.controls >>> .v-treeview-node__children {
  background-color: rgba(255, 255, 255, 0.08);
}
.spacer {
  height:20%;
}
.v-dialog {
  max-width: 820px;
}
.v-list-item--dense {
  min-height:28px;  
}
.v-list-item .v-list-item__title {
  padding:10px 10px;
}

@media only screen and (min-width: 760px) {
    .controls {
        width: 26%;
        display:none;
    }
    .controls.active {
        width:26%;
    }
}

@media only screen and (min-width: 1080px) {
    .controls {
        width: 24%;
    }
    .controls.active {
        width:24%;
    }
}

@media only screen and (min-width: 1480px) {
    .controls {
        width: 22%;
    }
    .controls.active {
        width:22%;
    }
}
</style>

<style>

.pdfcontent p {
  margin: 0;
  padding: 10px 12px;
}
.nbsp {
  white-space: nowrap;
}
#panoframe {
  width: 100%;
  height: 100%;
}
.v-dialog.main-dialog {  
  margin-bottom: 60px !important;
  max-height: 92%;
  max-width: 100%;
  margin-left:4px;
  margin-right:4px;
}
.v-dialog.pdf-wide {  
  margin-bottom: 60px !important;
  max-height: 92%;
  height:90%;  
  max-width: 100%;
  margin-left:4px;
  margin-right:4px;
}
.v-dialog img {
  max-width:100%;
  margin-bottom: 1rem !important;
}
.v-dialog.pdf-wide iframe { 
  height:100%;
}
.v-dialog.main-dialog iframe {
  height:450px;
} 
.v-dialog .poi-action {
  text-align:right;
  align-self: flex-end;
  padding:6px;
}
.v-dialog .poi-action.bottom {
  text-align:center;
  align-self: normal;
  width:100%;
}
.v-dialog .v-card {
  position:relative;
}
.v-dialog .titlewrap {  
  display: flex;
}
.v-dialog .wiwo21 {
  margin-left:12px;
  max-width: 100px;
  padding-top:10px;
}
.v-dialog .wiwo21 img {
  height:auto;
}
.v-dialog .headline {
  padding: 24px 24px 24px !important;
  font-size: 1.2rem !important;
  font-weight: 500;
  line-height: 1.1;
}
.v-dialog .headline.padding {
  padding: 12px 24px 12px !important;
  margin-left:0px;
}
.v-dialog .actionsmall {
  padding:10px;
  margin-left:auto;
}

.v-dialog .audiotour audio {
  width:100%;
  margin-bottom: 1rem;
}
.v-dialog .tourmap {
  width: 100%;
  padding-bottom: .4rem;
  position: sticky;
  top: 0;
  background-color: #fff;
}
.v-dialog.Campus-Audiotour .audiotour audio,
.v-dialog.Student.Audio .audiotour audio {
  position: sticky;
  top: 215px;
}

.v-dialog .tourwrap {
  width:100%;
  background-color:#f7f7f7;
  margin: 0 6px;
}
.poi-action .v-btn {  
  background-color:transparent !important;
  /*background-image: linear-gradient(to right, #f49e30, #ed7724);*/
}
.tourcontrol {
  border:0px solid red;  
  padding:4px;
}
.tourcontrol .v-sheet {
  border: 0px solid green;
  padding:4px;
}
.tourinfo {
  display: inline-block;
  padding:12px 12px 10px;
  margin-right: 12px;
}
.controlswrap button {
  margin-top:-4px;
}
.d-prev {
  float:left;
}
.d-next {
  float:right;
}
.d-prev,
.d-next {    
    width:30px;
    margin:10px 20px;
    background-color: rgba(255, 255, 255, 0);
    display:inline-block;
}
.d-prev:hover,
.d-next:hover {    
    background-color: rgba(255, 255, 255, 0.3);
}
.ql-align-right {
  float:right;
}
#panoSpot .v-card__text {
  padding: 16px 12px;
}
.login {
  display:none;
}
.pwinput {
  margin-bottom:20px;  
}
.menu {
  display:flex;
}

/* PDF viewer */
#viewerContainer .textLayer {
  display:none;
}
.easter {
  display:none;
}
.dialogframe iframe {
  max-width: 100%;
  display:block;
}

@media only screen and (min-width: 760px) {
    .v-dialog.main-dialog {      
      max-height: 92%;
      max-width: 64%;
      margin-right:24px;
      margin-left:24px;
    }
    .v-dialog.main-dialog.Audio-Guide,
    .v-dialog.main-dialog.Campus-Audiotour,
    .v-dialog.main-dialog.Student.Audio {  
      max-width: 68%;
    }
    .v-dialog.pdf-wide {  
      max-width: 80%;
      margin-right:24px;
      margin-left:24px;
    }
    .v-dialog .headline {
      font-size: 1.5rem;
    }
    .v-dialog .headline.padding {
      padding: 14px 24px 14px !important;
      margin-left:0px;
    }
    .v-dialog .wiwo21 {
      max-width: none;
    }
    .v-dialog .wiwo21 img {
     height:60px;
    }
    .controls {
        width: 26%;
    }
    .login {
      display:flex;
    }
    .menu {
      display:none;
    }
    .easter {
      display:block;
    }

}
@media only screen and (min-width: 1080px) {
    .controls {
        width: 21%;
    }
    .v-dialog.main-dialog.Audio-Guide,
    .v-dialog.main-dialog.Campus-Audiotour,
    .v-dialog.main-dialog.Student.Audio {  
      max-width: 44%;
    }
}
@media only screen and (min-width: 1480px) {
    .controls {
        width: 20%;
    }
    .v-dialog.main-dialog.Audio-Guide,
    .v-dialog.main-dialog.Campus-Audiotour,
    .v-dialog.main-dialog.Student.Audio {  
      max-width: 44%;
    }
}
</style>